import './ProductsDropdown.css';

import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';
import useGetProducts from '../../hooks/useGetProducts';
import { generateClassName, generateSelectField } from '../../../b2b-common/helpers';
import { findProductById } from './helper';

const ProductsDropdown = ({ defaultProductId = null, className = null, onProductSelected = null }) => {
    const { t } = useB2BTranslation('b2b-users');
    const { productsData, fetchingProductsData } = useGetProducts();

    const generateSelectItems = (products, level = 0) => {
        return products.reduce((acc, product) => {
            const indent = '..... '.repeat(level);
            acc.push({
                value: product.productId,
                label: `${indent} ${product.productName} - ${product.productAcronym}`,
                default: product.productId === defaultProductId,
            });
            if (product.childProducts && product.childProducts.length > 0) {
                acc = acc.concat(generateSelectItems(product.childProducts, level + 1));
            }
            return acc;
        }, []);
    };

    const selectItems = [
        ...generateSelectItems(productsData),
    ];

    const handleProductSelected = (e) => {
        const selectedProductId = parseInt(e.target.value, 10);
        if (onProductSelected) {
            const selectedProduct = findProductById(productsData, selectedProductId);
            onProductSelected(selectedProduct);
        }
    };

    return (
        generateSelectField(selectItems,
            {
                label: t('Parent Product'),
                value: defaultProductId,
                onChange: handleProductSelected,
                className: generateClassName('products-dropdown', '', className),
            })
    );
}

export default ProductsDropdown;